/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import Header2 from "ui/kit/typography/Header2";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {LibraryRow_piece$data} from "./__generated__/LibraryRow_piece.graphql";
import styles from "./LibraryRow.module.scss";
import {Link} from "react-router-dom";
import {LibraryDetail} from "constants/paths";

interface Props {
    piece: LibraryRow_piece$data
}

const LibraryRow: React.FC<Props> = ({piece}) => {
    return (
        <Link to={LibraryDetail(piece.id)}>
            <div className={styles.container}>
                <Header2>{piece.name || "Unnamed Music Piece"}</Header2>
            </div>
        </Link>
    );
}

export default createFragmentContainer(
    LibraryRow,
    {
        piece: graphql`
        fragment LibraryRow_piece on MusicPiece {
            id
            name
        }
        `
    }
);